"use client"; 
import { useState } from "react";
import Link from "next/link";
import CustomButton from "../Buttons/CustomButton";
import cl1Tab from "@/Helper/images/client_centric_approach.png";
import cl2Tab from "@/Helper/images/commitment_to_innovation.png";
import cl3Tab from "@/Helper/images/ethical_data_practices.png";
import cl4Tab from "@/Helper/images/end_to_end_expertise.png";

import Image from "next/image";

export default function IndustryComponent() {
  const [activeTab, setActiveTab] = useState(0); // State for active tab

  const handleTabClick = (index) => {
    setActiveTab(index); // Update the active tab state
  };

  const tabTitles = [
    "Seamless Transition",
    "Future-Ready Platforms",
    "Tailored Migration Strategies",
    "Data Integrity Guaranteed",
    "Accelerated Insights Post-Migration",
   
  ];

  const tabContent = [
    {
      heading: "Seamless Transition",
      subheading: "We ensure a smooth migration process with zero disruptions to your operations, maintaining data integrity and performance throughout.",
      image: cl1Tab, 
    },
    {
      heading: "Future-Ready Platforms",
      subheading: " We modernize your BI systems by migrating to scalable, cutting-edge platforms like Power BI, Tableau, or Looker, unlocking new levels of functionality. ",
      image: cl2Tab,
    },
    {
      heading: "Tailored Migration Strategies",
      subheading: " Our migration plans are customized to your specific needs, ensuring optimal alignment with your business goals and technical environment.",
      image: cl3Tab,
    },
    {
      heading: "Data Integrity Guaranteed",
      subheading: "We prioritize the accuracy and completeness of your data during migration, ensuring that no insights are lost in the transition.",
      image: cl4Tab,
    },
    {
      heading: "Accelerated Insights Post-Migration",
      subheading: " With optimized configurations and enhanced visualizations, we empower you to extract actionable insights faster than ever after the migration.",
      image: cl4Tab,
    },
   
  ];

  return (
    <div className="industry_cat_section1">
      {/* Navigation Tabs */}
      <div className="industry_cat_nav1">
        {tabTitles.map((tab, index) => (
          <p
            key={index}
            className={index === activeTab ? "active" : ""}
            onClick={() => handleTabClick(index)}
            
          >
            {tab}
          </p>
        ))}
      </div>

      {/* Tab Content */}
      {tabContent.map((content, index) => (
        <div
          key={index}
          className={`industry_container1 ${
            index === activeTab ? "active" : ""
          }`}
        >
          <div className="industry_left_content1">
            <p className="heading1">{content.heading}</p>
            <p className="subheading1">{content.subheading}</p>
            
          </div>
          <div className="industry_right_content1">
            <div className="slider_bg1 normal_bg1">
            <Image
              src={tabContent[activeTab].image}
              alt={tabContent[activeTab].heading}
              width={457}
              height={257}
              className="productbanner_imageslider"
              loading="eager"
            />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
